import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import Table from "../CommonControlls/TableRendrer";
import { Link } from "react-router-dom";
import {
	SelectAllDistricts,
	SelectAllProvince,
	SelectAllXpertSites,
	SelectAllHCF,
	SelectAllRiders,
} from "../OfflineDb/IndexDbTranscSP";
import AlertModal from "../CommonControlls/AlertModal";
import DropDown from "../CommonControlls/DropdownRendrer";
import jsPDF from "jspdf";

const mapStateToProps = (store) => {
	return store;
};

const mapDispatchToProps = (dispatch) => {
	return {
		ShowAlert: (Settings) => {
			dispatch({ type: "UpdateAlert", payload: Settings });
		},
		ShowLoader: (Isloading) => {
			dispatch({ type: "UpdateLoader", payload: Isloading });
		},
	};
};

class HCFCluster_List extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// Table
			data: [],
			page: 1,
			sizePerPage: 15,
			TotalRecord: 0,
			loading: false,
			exportLoading: false,
			ExportLoading: false,

			sortField: "id",
			idsortOrder: "desc",
			provinceNamesortOrder: "",
			districtNamesortOrder: "",
			typeIdsortOrder: "",
			namesortOrder: "",

			permissions: [],

			alertModalData: {
				title: "",
				message: "",
				First_Callback: () => {},
				Second_Callback: () => {},
				type: 1,
			},

			XpertSiteLoader: false,
			XpertSitelist: [],
			XpertSiteId: 0,

			ProvinceLoader: false,
			Provincelist: [],
			ProvinceId: [],

			SrList: [],
			SrId: [],

			loadingExport: false,

			DistrictLoader: false,
			Districtlist: [],
			FilteredDistrictlist: [],
			DistrictId: [],

			HCFlist: [],
			Riderslist: [],

			HCFTypelist: [
				{ id: 1, name: "Bhu to Rhc cluster" },
				{ id: 3, name: "Bhu to Xpert cluster" },
				{ id: 2, name: "Rhc to Xpert cluster" },
			],
			ClusterTypeId: 0,
		};
	}

	HandleAutoSuggestValChange = (fieldId, value) => {
		this.setState(
			{
				[fieldId]: value,
				// isSaveSearch: this.state.isSearchChanged ? true : false
			},
			() => {
				if (fieldId === "ProvinceId") {
					this.FilterDistricts(value);
				}
				if (fieldId === "SrId") {
					const tempDistricts = this.state.Districtlist;
					const tempSrs = this.state.SrId;
					var selectedSrs = Common.ConvertToCommaSplitArray(tempSrs, "id");
					var filteredSelectedDistricts = tempDistricts.filter(
						(obj) => selectedSrs.indexOf(obj.subrecipientid) > -1
					);
					this.setState({
						FilteredDistrictlist: filteredSelectedDistricts,
					});
				}
				// if(fieldId === 'DistrictId') {
				//     var selectedDistricts = this.state.DistrictId
				//     var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(selectedDistricts, "id")
				//
				//     const TempSr = this.state.SrList
				//     const filtered = TempSr.filter((el) => {
				//         return filteredDistrictIdArr.indexOf(el.districtId) > -1
				//     })
				//
				//     this.setState({
				//         FilteredSrs: filtered
				//     })
				// }
			}
		);
	};
	FilterDistricts = (value) => {
		// filter ditrict list
		var TempArr = this.state.Districtlist;
		var selectedProvince = Common.ConvertToCommaSplitArray(value, "id");
		var filteredDistrictList = TempArr.filter(function (obj) {
			return selectedProvince.indexOf(obj.provinceId) > -1;
		});

		// filter district selected values
		var selectedDistricts = this.state.DistrictId;
		var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(
			filteredDistrictList,
			"id"
		);
		var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
			return filteredDistrictIdArr.indexOf(obj.id) > -1;
		});

		const tempSrs = this.state.SrList;
		const filteredSrs = tempSrs.filter(
			(item) => selectedProvince.indexOf(item.provinceid) > -1
		);

		this.setState({
			// FilteredDistrictlist: filteredDistrictList,
			// DistrictId: filteredSelectedDistricts,
			FilteredSrs: filteredSrs,
		});
	};

	handleChecked = async (checked, row) => {
		const data = new URLSearchParams({ id: row.id, isActive: checked });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			`${Common.APILinks.Update_HCFClusterStatus}?${data}`,
			{},
			(resp) => {
				this.PopulateTable();
			},
			(error) => {
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	render() {
		const CellMenu = (cell, row) => {
			return (
				<div>
					{this.state.permissions.includes("bhusrhcscluster-update") && (
						<Link to={"/BHUAndRHCClusters_Edit/" + row.id}>
							<button
								data-toggle="tooltip"
								title="Edit"
								className="btn TableRow_btn"
							>
								<i
									className="fa fa-pencil-square-o text-primary"
									aria-hidden="true"
								/>
							</button>
						</Link>
					)}
					{this.state.permissions.includes("bhusrhcscluster-delete") && (
						<button
							onClick={() => this.onDelete(row.id)}
							data-toggle="tooltip"
							title="Delete"
							className="btn TableRow_btn"
						>
							<i className="fa fa-trash-o text-danger" aria-hidden="true" />
						</button>
					)}
				</div>
			);
		};

		const columns = [
			{
				dataField: "id",
				text: "Id",
				sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "120px" };
				},
			},
			{
				dataField: "provinceName",
				text: "Province",
				sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "120px" };
				},
			},
			{
				dataField: "subRecipient_ShortName",
				text: "Sr. Name",
				headerStyle: () => {
					return { fontSize: "13px", width: "100px" };
				},
				sort: true,
			},

			{
				dataField: "districtName",
				text: "District Name",
				headerStyle: () => {
					return { fontSize: "13px", width: "100px" };
				},
				sort: true,
			},

			{
				dataField: "subtype",
				text: "Type",
				sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "150px", fontSize: "13px" };
				},
				formatter: (cell, row) => {
					return (
						<span>
							{cell === 1
								? "BHU to RHC Cluster"
								: cell === 2
								? "RHC to Xpert Cluster"
								: cell === 3
								? "BHU to Xpert Cluster"
								: cell}
						</span>
					);
				},
				csvFormatter: (typeId) =>
					typeId === 1
						? "BHU to RHC Cluster"
						: typeId === 2
						? "RHC to Xpert Cluster"
						: typeId === 3
						? "BHU to Xpert Cluster"
						: "",
			},

			{
				dataField: "rideType",
				text: "Price Type",
				sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "110px", fontSize: "13px" };
				},
				csvExport: true,
			},
			{
				dataField: "name",
				text: "Cluster Name",
				sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "135px", fontSize: "13px" };
				},
			},
			{
				dataField: "hcfName",
				text: "BHUs / RHCs",
				// sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "160px", fontSize: "13px" };
				},
				csvFormatter: (cell, row) => row.hcfListName,
			},

			{
				dataField: "destinationName",
				text: "Destination",
				// sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "110px", fontSize: "13px" };
				},
			},

			{
				dataField: "cutOffTime",
				text: "Cut Off Time",
				// sort: true,

				formatter: (cell, row) => {
					var cutOffDatetime = cell;
					if (cutOffDatetime != null) {
						cutOffDatetime = Common.ConvertToLocalDateTime(cutOffDatetime);
						var arr = cutOffDatetime.split(" ");
						var time = Common.get12hrTime(arr[3] + " " + arr[4]);
					}
					return time;
				},
				headerStyle: (colum, colIndex) => {
					return { width: "160px", fontSize: "13px" };
				},
				csvFormatter: (cutOffTime) => Common.ConvertToLocalDateTime(cutOffTime),
			},

			{
				dataField: "deliverybatchsize",
				text: "Batch Size",
				// sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "110px", fontSize: "13px" };
				},
			},

			{
				dataField: "ridersName",
				text: "Riders",
				// sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "140px", fontSize: "13px" };
				},
				csvFormatter: (cell, row) => row.ridersListName,
			},
			{
				dataField: "isActive",
				text: "Active",
				headerStyle: () => {
					return { width: "80px", fontSize: "13px" };
				},
				formatter: (cell, row) => {
					return (
						<div
							className="col-md-2"
							style={{ marginTop: "10px", marginLeft: "20px" }}
						>
							<label className="CheckBox_container Roles_CheckBox">
								<input
									type="checkbox"
									defaultChecked={cell}
									onClick={(e) => this.handleChecked(e.target.checked, row)}
								/>
								<span className="CheckBox_checkmark"></span>
							</label>
						</div>
					);
				},
			},
			{
				dataField: "",
				text: "Actions",
				headerStyle: (colum, colIndex) => {
					return { width: "100px" };
				},
				formatter: (cell, row) => {
					return CellMenu(cell, row);
				},
				csvExport: false,
			},
		];
		return (
			<div>
				<AlertModal {...this.state.alertModalData} />
				<MainLayout />
				<div id="right-panel" className="right-panel">
					<Topmenu
						PageTitle="BHUs & RHCs Cluster"
						isShowAddBtn={this.state.permissions.includes(
							"bhusrhcscluster-add"
						)}
						AddBtnLabel="Add Cluster"
						AddBtnLink="/BHUAndRHCClusters_Add"
					/>
					<div className="content">
						{/* <div className="PageHeader_Container">
                            <h2 className="Pageheading">Groups</h2>
                            <div className="PageMenu_Container"><Link to="BHUAndRHCClusters_Add"><button type="submit" id="Form_SaveBtn" className="btn btn_style2">Add Group</button></Link></div>
                        </div> */}

						<div className="card">
							<div className="card-body">
								<div className="Table_Search row">
									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Province</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="ProvinceId"
											options={this.state.Provincelist}
											val={this.state.ProvinceId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.ProvinceLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Sub Recipient</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="SrId"
											options={this.state.FilteredSrs}
											val={this.state.SrId}
											addPlaceholder=""
											disabled={false}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">District</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="DistrictId"
											options={this.state.FilteredDistrictlist}
											val={this.state.DistrictId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.DistrictLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									{/* <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label for="">Xpert Site</label>
                                        <DropDown
                                            multi={false}
                                            dropdownRenderer = {false}
                                            create = {false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="XpertSiteId"
                                            options={this.state.XpertSitelist}
                                            val={this.state.XpertSiteId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={this.state.XpertSiteLoader}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={false}
                                            placeholder="Select"
                                        />
                                    </div> */}

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Type</label>
										<DropDown
											multi={false}
											dropdownRenderer={false}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="ClusterTypeId"
											options={this.state.HCFTypelist}
											val={this.state.ClusterTypeId}
											addPlaceholder=""
											disabled={false}
											loading={false}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={false}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Cluster Name</label>
										<input
											autoComplete="off"
											type="text"
											className="form-control Search_InputField"
											id="SearchName"
											placeholder="Enter cluster name"
										/>
									</div>

									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<button
											onClick={() => {
												this.PopulateTable();
											}}
											id="FormSearchBtn"
											className="btn SearchTable_Btn"
											style={{ position: "relative", marginTop: 36 }}
										>
											Search
										</button>
									</div>
								</div>

								{/* <div className="TableTop_Buttons">
                                    <span onClick={() => { $(".react-bs-table-csv-btn").click()}} className="TableExport_button"><i className="fa fa-download" aria-hidden="true"></i> Export</span>
                                </div> */}

								<Table
									keyField="id"
									data={this.state.data}
									page={this.state.page}
									sizePerPage={this.state.sizePerPage}
									totalSize={this.state.TotalRecord}
									exportPdf={this.ExportPdf}
									onTableChange={this.handleTableChange}
									changeSizePerPage={(size) => {
										setTimeout(() => {
											this.setState({
												exportLoading: true,
											});
											this.ExportData(size);
										}, 100);
									}}
									exportAllowed={this.state.permissions.includes(
										"bhusrhcscluster-export"
									)}
									isPagination={true}
									exportLoading={this.state.ExportLoading}
									pdfExportLoading={this.state.loadingExport}
									columns={columns}
									loading={this.state.loading}
									RefreshTable={this.PopulateTable}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	componentWillMount() {
		if (this.props.UserAuthentication.AuthToken === "") {
			this.props.history.push("/Login");
		}
	}

	componentDidMount() {
		Common.AddClassToMenueLink("MenuLink_HCFClusters");
		this.GetPageConfigData(() => {
			this.PopulateTable();
		});
		$(".Search_InputField").on("keypress", (e) => {
			if (e.which === 13) {
				this.PopulateTable();
			}
		});

		this.SelectSubReciepents();

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_RolesPermissions,
			{
				pageSize: 15,
				pageNumber: 1,
			},
			(resp) => {
				const modifiedPermissions = resp.data
					.filter(
						(p) =>
							p.permissioN_GROUP === "BHUsRHCsCluster" && p.permissioN_ALLOWED
					)
					.map((d) => d.permissioN_NAME);
				this.setState({ permissions: modifiedPermissions });
			}
		);
	}

	GetPageConfigData = (CallBack) => {
		this.props.ShowLoader({ Isloading: true });
		var d1 = $.Deferred();
		var d2 = $.Deferred();
		var d3 = $.Deferred();
		var d4 = $.Deferred();
		var d5 = $.Deferred();
		this.SelectProvinces(() => {
			d1.resolve();
		});
		this.SelectDistricts(() => {
			d2.resolve();
		});
		this.SelectXpertSites(() => {
			d3.resolve();
		});
		this.SelectHCF(() => {
			d4.resolve();
		});
		this.SelectRiders(() => {
			d5.resolve();
		});

		$.when(d1, d2, d3, d4, d5).done(() => {
			this.props.ShowLoader({ Isloading: false });
			CallBack();
		});
	};
	SelectProvinces = (Callback) => {
		this.setState({ ProvinceLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Province,
			{},
			(data) => {
				this.setState({
					ProvinceLoader: false,
					Provincelist: data.data.sort(Common.compare),
				});
				Callback();
			},
			(error) => {
				this.setState({ ProvinceLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectDistricts = (Callback) => {
		this.setState({ DistrictLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_District,
			{},
			(data) => {
				this.setState({
					DistrictLoader: false,
					Districtlist: data.data.sort(Common.compare),
				});
				Callback();
			},
			(error) => {
				this.setState({ DistrictLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectXpertSites = (Callback) => {
		this.setState({ XpertSiteLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_XpertSites,
			{},
			(data) => {
				this.setState({
					XpertSiteLoader: false,
					XpertSitelist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ XpertSiteLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectHCF = (Callback) => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_HCF,
			{},
			(data) => {
				this.setState({
					HCFlist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ DistrictLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectSubReciepents = () => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectALl_SubRecipient,
			{},
			(resp) => {
				if (resp.status) {
					this.setState({
						SrList: resp.data.map((d) => ({
							id: d.id,
							name: d.short_name,
							districtId: d.districtid,
							...d,
						})),
					});
				}
			}
		);
	};
	SelectRiders = (Callback) => {
		this.setState({ RiderLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.Select_RiderProfiles_withouDetails,
			{
				sortField: "id",
				sortOrder: "ase",
				pageNumber: 1,
				pageSize: 3500,
			},
			(data) => {
				this.setState({
					Riderslist: data.data,
					RiderLoader: false,
				});
				Callback();
			},
			(error) => {
				this.setState({
					RiderLoader: false,
				});
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	handleTableChange = (
		type,
		{ page, sizePerPage, filters, sortField, sortOrder }
	) => {
		if (type === "sort") {
			let tempFieldorderLabel = sortField + "sortOrder";
			let tempFieldorder =
				this.state[tempFieldorderLabel] === ""
					? sortOrder
					: this.state[tempFieldorderLabel] === "asc"
					? "desc"
					: "asc";
			this.setState(
				{
					sortField,
					[tempFieldorderLabel]: tempFieldorder,
				},
				() => {
					this.PopulateTable();
				}
			);
			return;
		}
		this.setState(
			{
				page,
				sizePerPage,
			},
			() => {
				this.PopulateTable();
			}
		);
	};
	ExportPdf = () => {
		const doc = new jsPDF();
		this.setState({ loadingExport: true });

		var provinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";

		var Parameters = {
			name: $("#SearchName").val(),
			pageSize: this.state.TotalRecord,
			pageNumber: this.state.page,
			provinceIdString,
			districtIdString,
			xpertSiteId: this.state.XpertSiteId,
			typeId: this.state.ClusterTypeId,
			srId: this.state.SrId,
			srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
			sortField: this.state.sortField,
			sortOrder: this.state[this.state.sortField + "sortOrder"],
		};
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_HCFCluster,
			Parameters,
			(resp) => {
				if (resp.status) {
					if (resp.data.length > 0) {
						var ProcessedXpertSite = Common.ProcessDataInArray(
							this.state.XpertSitelist,
							"id"
						);

						var ProcessedHCF = Common.ProcessDataInArray(
							this.state.HCFlist,
							"id"
						);
						
						var ProcessedRiders = Common.ProcessDataInArray(
							this.state.Riderslist,
							"id"
						);
						
						for (var i in resp.data) {
							resp.data[i].hcfName = Common.GetIdsLabelString(
								resp.data[i].pickupIds,
								ProcessedHCF
							);
							resp.data[i].hcfListName = Common.GetIdsCompleteLabelString(
								resp.data[i].pickupIds,
								ProcessedHCF
							);
							resp.data[i].ridersName = Common.GetIdsLabelString(
								resp.data[i].riderIds,
								ProcessedRiders
							);
							resp.data[i].ridersListName = Common.GetIdsCompleteLabelString(
								resp.data[i].riderIds,
								ProcessedRiders
							);
							resp.data[i].destinationName =
								resp.data[i].typeId === 1
									? ProcessedHCF[resp.data[i].rhcId]?.name
									: ProcessedXpertSite[resp.data[i].xpertSiteId]?.name;
						}
						doc.autoTable({
							theme: "grid",
							body: [...resp.data],
							columns: [
								{ header: "id", dataKey: "id" },
								{ header: "Name", dataKey: "name" },
								{ header: "HCF Name", dataKey: "hcfName" },
								{ header: "HCF List", dataKey: "hcfListName" },
								{ header: "Riders Name", dataKey: "ridersName" },
								{ header: "SR", dataKey: "subRecipient_ShortName" },
								{ header: "Destination", dataKey: "destinationName" },
								{ header: "Contact", dataKey: "contact" },
								{ header: "Province", dataKey: "provinceName" },
								// {header: 'Tehsil', dataKey: 'tehsilName'},
								{ header: "District", dataKey: "districtName" },
							],
						});

						this.setState({ loadingExport: false });
						doc.save("bhu.pdf");
					}
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	ExportData = (size) => {
		$("#FormSearchBtn").prop("disabled", true);
		this.setState({ ExportLoading: true, loading: true });

		var provinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";

		var Parameters = {
			name: $("#SearchName").val(),
			pageSize: this.state.TotalRecord,
			pageNumber: this.state.page,
			provinceIdString,
			districtIdString,
			xpertSiteId: this.state.XpertSiteId,
			typeId: this.state.ClusterTypeId,
			srId: this.state.SrId,
			srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
			sortField: this.state.sortField,
			sortOrder: this.state[this.state.sortField + "sortOrder"],
		};
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_HCFCluster,
			Parameters,
			(resp) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false });
				if (resp.status) {
					if (resp.data.length > 0) {
						var ProcessedXpertSite = Common.ProcessDataInArray(
							this.state.XpertSitelist,
							"id"
						);
						var ProcessedHCF = Common.ProcessDataInArray(
							this.state.HCFlist,
							"id"
						);
						var ProcessedRiders = Common.ProcessDataInArray(
							this.state.Riderslist,
							"id"
						);
						for (var i in resp.data) {
							resp.data[i].hcfName = Common.GetIdsLabelString(
								resp.data[i].pickupIds,
								ProcessedHCF
							);
							resp.data[i].hcfListName = Common.GetIdsCompleteLabelString(
								resp.data[i].pickupIds,
								ProcessedHCF
							);
							resp.data[i].ridersName = Common.GetIdsLabelString(
								resp.data[i].riderIds,
								ProcessedRiders
							);
							resp.data[i].ridersListName = Common.GetIdsCompleteLabelString(
								resp.data[i].riderIds,
								ProcessedRiders
							);
							resp.data[i].destinationName =
								resp.data[i].typeId === 1
									? ProcessedHCF[resp.data[i].rhcId]?.name
									: ProcessedXpertSite[resp.data[i].xpertSiteId]?.name;
						}
					}
					this.setState({
						data: resp.data,
						TotalRecord: resp.TotalRecord,
						exportLoading: false,
						ExportLoading: false,
					});
					$(".react-bs-table-csv-btn").click();

					setTimeout(() => {
						this.PopulateTable();
					}, 500);
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false, ExportLoading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	PopulateTable = () => {
		$("#FormSearchBtn").prop("disabled", true);
		this.setState({ loading: true, data: [], TotalRecord: 0 });

		var provinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
		var subrecipientId =
			this.state.SrId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

		var Parameters = {
			name: $("#SearchName").val(),
			pageSize: this.state.sizePerPage,
			pageNumber: this.state.page,
			provinceIdString,
			districtIdString,
			xpertSiteId: this.state.XpertSiteId,
			typeId: this.state.ClusterTypeId,
			srId: subrecipientId,
			srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
			sortField: this.state.sortField,
			sortOrder: this.state[this.state.sortField + "sortOrder"],
		};
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_HCFCluster,
			Parameters,
			(resp) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false });
				if (resp.status) {
					if (resp.data.length > 0) {
						var ProcessedXpertSite = Common.ProcessDataInArray(
							this.state.XpertSitelist,
							"id"
						);
						var ProcessedHCF = Common.ProcessDataInArray(
							this.state.HCFlist,
							"id"
						);
						console.log(ProcessedHCF)
						var ProcessedRiders = Common.ProcessDataInArray(
							this.state.Riderslist,
							"id"
						);
						for (var i in resp.data) {
							//console.log(resp.data[i].pickupIds)
							resp.data[i].hcfName = Common.GetIdsLabelString(
								resp.data[i].pickupIds,
								ProcessedHCF
							);
							resp.data[i].hcfListName = Common.GetIdsCompleteLabelString(
								resp.data[i].pickupIds,
								ProcessedHCF
							);
							resp.data[i].ridersName = Common.GetIdsLabelString(
								resp.data[i].riderIds,
								ProcessedRiders
							);
							resp.data[i].ridersListName = Common.GetIdsCompleteLabelString(
								resp.data[i].riderIds,
								ProcessedRiders
							);
							resp.data[i].destinationName = !resp.data[i].xpertSiteId
								? ProcessedHCF[resp.data[i].rhcId]?.name
								: ProcessedXpertSite[resp.data[i].xpertSiteId]?.name;
						}
					}
					this.setState({
						data: resp.data,
						TotalRecord: resp.totalRecord,
					});
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	onDelete = (id) => {
		this.setState(
			{
				alertModalData: {
					title: "Delete HFC cluster",
					message: "Are you sure you want to delete this record.",
					First_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
						this.DeleteRecord(id);
					},
					Second_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
					},
					type: 1,
				},
			},
			() => {
				$("#Show_ArletModal").click();
			}
		);
	};
	DeleteRecord = (id) => {
		this.props.ShowLoader({ Isloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.Delete_HCFCluster,
			{ id: id },
			(Result) => {
				if (Result.status) {
					this.PopulateTable();
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully." });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				} else {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(HCFCluster_List);
